import { render, staticRenderFns } from "./InputPhone.vue?vue&type=template&id=5798e374&scoped=true&"
import script from "./InputPhone.vue?vue&type=script&lang=js&"
export * from "./InputPhone.vue?vue&type=script&lang=js&"
import style0 from "./InputPhone.vue?vue&type=style&index=0&id=5798e374&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5798e374",
  null
  
)

export default component.exports